export default __webpack_public_path__ + "static/media/3.349997db.png";